import { TypeOf } from 'io-ts/Decoder';

import { iLiteral } from '@dmb/core';

export const DmbLanguageC = iLiteral('de', 'en', 'fr');
export type DmbLanguage = TypeOf<typeof DmbLanguageC>;
export const dmbLanguages = DmbLanguageC.values;

export const isDmbLanguage = (i: unknown): i is DmbLanguage => !!i && dmbLanguages.includes(i as DmbLanguage);
